/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";
import Dropdown from "react-dropdown";
import { get } from "lodash";

/**
 * Internal dependencies
 */
import useReportBuilder from "modules/report-builder/use-report-builder";

const ConfigureLabelAngle = () => {
  const { report, editReport } = useReportBuilder();

  const options = [
    { value: "0", label: "Zero" },
    { value: "-45", label: "-45 Degrees" },
  ];

  const handleChange = ({ value }) => {
    editReport({ config: { axisTickAngle: value } });
  };

  return (
    <Box>
      <Text size="xsmall">Axis tick label Angle</Text>
      <Dropdown
        value={get(report, "config.axisTickAngle", "0")}
        onChange={handleChange}
        options={options}
      />
    </Box>
  );
};

export default ConfigureLabelAngle;
